import React, { FC, HTMLAttributes, useMemo } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { detailNavsPublic, detailNavsPrivate } from './constants';
import classNames from 'classnames';
import { useQuery } from '@redux-requests/react';
import { AppsConstants } from 'modules/userApps/store/constants';
import { t } from 'utils';
import { SubmitAppButton } from 'components';

import styles from './DetailNav.module.scss';

export interface INavParams {
  id: string;
}

const DetailNav: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const { className } = props;
  const { id } = useParams<INavParams>();
  const {
    data: { isPublic, status },
  } = useQuery({ type: AppsConstants.APP, requestKey: id });
  const rootClassName = classNames(styles.root, className);
  const navList = useMemo(() => {
    if (isPublic) return detailNavsPublic;
    return detailNavsPrivate;
  }, [isPublic]);

  return (
    <div className={rootClassName}>
      <ul className={styles.list}>
        {navList.map(({ title, route }) => (
          <li key={title}>
            <NavLink
              to={route(id)}
              className={classNames(styles.link)}
              activeClassName={styles.active}
              exact
            >
              {t(title)}
            </NavLink>
          </li>
        ))}
      </ul>
      <SubmitAppButton status={status} id={id} />
    </div>
  );
};

export default DetailNav;
